import { createReducer, on } from '@ngrx/store';

import { setTargetRatesShowRecessions } from './show-recessions.actions';

export const showRecessions = createReducer(
    false,
    on(setTargetRatesShowRecessions, (state: boolean, action) => {
        return action.showRecessions;
    })
);
